"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWhitespace = exports.isLikelyUrlWithoutProtocol = void 0;

var isLikelyUrlWithoutProtocol = function isLikelyUrlWithoutProtocol(possibleUrl) {
  var splitUrl = possibleUrl.split(/([/?].*)/);
  var domainString = splitUrl[0];
  var pathString = splitUrl[1] || '';
  var domainReg = /^([a-zA-Z0-9-]{1,61}\.){0,126}[a-zA-Z0-9-]{1,61}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?\/{0,1}$/;
  var pathReg = /^\/([^\s/]+?\/{0,1})*(\?[^\s/]*?)*?$|^$|^\?[^\s]*?$/;
  return domainReg.test(domainString) && pathReg.test(pathString);
};

exports.isLikelyUrlWithoutProtocol = isLikelyUrlWithoutProtocol;

var isWhitespace = function isWhitespace(input) {
  return !input.trim();
};

exports.isWhitespace = isWhitespace;